<template>
  <!-- 客户优惠券 -->
  <div class="userCoupon">
    <!-- 面包屑导航 -->
    <!-- <crumbs-bar @refresh="handleRefresh" :crumbsList="['优惠券',$route.meta.title]">
    </crumbs-bar> -->
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </page-header>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <!-- <el-date-picker
          v-model="searchForm.Time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          style="margin-right: 5px"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <label class="label">是否使用：</label>
        <el-select
          placeholder="是否使用"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="未使用" value="0"></el-option>
          <el-option label="已使用" value="2"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="优惠券编号"
          v-model="searchForm.code"
        ></el-input>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="客户名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" @click="seach" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="couponCode"
        show-overflow-tooltip
        label="优惠券编码"
      >
      </el-table-column>
      <el-table-column
        prop="couponName"
        align="center"
        show-overflow-tooltip
        label="优惠券名称"
      >
      </el-table-column>
      <el-table-column
        prop="username"
        label="用户名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        prop="erp_dwbh"
        label="Erp编号"
        align="center"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="businessname"
        label="客户名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        prop="shouhdz"
        label="送货地址"
        align="center"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="ReceiveTime"
        label="领取时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="typeName"
        label="渠道类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="receivingType"
        label="领取类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sceneName"
        label="使用范围"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="coupontype"
        label="优惠类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="fullAmount"
        label="满足金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="deduction"
        label="优惠金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="discount"
        label="优惠折扣"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="OrderId"
        label="订单号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="order_amount"
        label="订单金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="UseTime"
        label="使用时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        label="操作"
        width="160"
        align="center">
        <template slot-scope="scope">
          <el-button type="primary" style="padding:2px 3px;" plain @click="couponDetail(scope.row)">查看</el-button>
          <el-button type="warning" style="padding:2px 3px;" plain @click="grantCoupon(scope.row)">下发</el-button>
          <el-button type="danger" style="padding:2px 3px;" plain @click="changeStatus(scope.row,2)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "userCoupon",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        status: "99",
        code: "",
        name: "",
        Time: [], //时间范围
        startTime: "",
        endTime: "",
      },
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    // 接受路由跳转传递的参数
    if ("couponCode" in this.$route.params) {
      this.searchForm.code = this.$route.params.couponCode;
    }
    this.getTableData();
  },
  methods: {
    /**返回 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },

    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      if (this.searchForm.Time == null) {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      } else {
        this.searchForm.startTime = this.searchForm.Time[0];
        this.searchForm.endTime = this.searchForm.Time[1];
      }
      let data = {
        type: "HtGetUserCoupon",
        couponCode: this.searchForm.code,
        sqlValue: this.searchForm.name,
        status: this.searchForm.status,
        // startTime: this.searchForm.startTime,
        // endTime: this.searchForm.endTime,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_MemberCoupon"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = (res.data || []).map((item) => {
              if (item.UseTime == "1900/1/1 0:00:00") {
                item.UseTime = "";
              }
              return item;
            });
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    // 导出数据
    exportData() {
      let data = {
        type: "HtGetUserCoupon",
        couponCode: this.searchForm.code,
        sqlValue: this.searchForm.name,
        status: this.searchForm.status,
        PageIndex: 1,
        PageSize: 99999,
      };
      let proc = "Proc_MemberCoupon";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name= 客户优惠券";
    },
  },
};
</script>

<style scoped>
.userCoupon {
  width: 100%;
  height: 100%;
}
.couponView {
  width: 100%;
  height: 100%;
  list-style: none;
}
.couponView > li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  list-style: none;
}
.couponTitle {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #000;
  line-height: 40px;
}
.couponText {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #ccc;
  line-height: 40px;
}
</style>
